import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { useLazyGetDocumentsByBatchQuery } from '../../../store/ai/documents'
import { selectAccountId } from '../../../store/auth/authSlice'
import { selectDocumentBatchDocuments, setDocumentBatchDocuments } from '../../../store/processDocument/documentBatch'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'

import { useDocumentLeaveBypass } from '../DocumentLeaveBypassContext'

export const useRefetchDocumentBatch = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { bypassOnce } = useDocumentLeaveBypass()

  const accountId = useAppSelector(selectAccountId)
  const documents = useAppSelector(selectDocumentBatchDocuments)

  const [triggerGetDocumentsByBatch] = useLazyGetDocumentsByBatchQuery()

  const documentBatchId = documents[0]?.documentBatchId

  const refetchDocumentBatch = useCallback(async () => {
    if (!documentBatchId) {
      return
    }

    try {
      const documents = await triggerGetDocumentsByBatch({ accountId, documentBatchId }).unwrap()
      const remainingDocuments = documents ?? []

      dispatch(setDocumentBatchDocuments(remainingDocuments))

      if (!remainingDocuments.length) {
        bypassOnce()
        navigate('/documents/upload')
      }
    } catch (e) {
      console.error(e)
    }
  }, [accountId, bypassOnce, dispatch, documentBatchId, navigate, triggerGetDocumentsByBatch])

  return { refetchDocumentBatch }
}
